import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'baseline',
            justifyContent: 'start'
        },
        /**
         * Single-cell grid: the invisible sizer and the visible content (live
         * values or loading placeholder) share the cell, so the slot is always
         * at least as wide as the reserved sample and never shifts when the
         * price or the day change arrives.
         */
        ltp: {
            display: 'grid',
            gridTemplateColumns: 'max-content',
            whiteSpace: 'nowrap'
        },
        slot: {
            gridArea: '1 / 1'
        },
        sizer: {
            gridArea: '1 / 1',
            visibility: 'hidden',
            pointerEvents: 'none',
            userSelect: 'none'
        },
        placeholder: {
            color: 'transparent',
            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)',
            borderRadius: 4,
            userSelect: 'none'
        }
    }
})
